export default __webpack_public_path__ + "static/media/draw-2.929db0ed.jpg";